/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export type ActivityTagValue =
    | 'biking'
    | 'climbing'
    | 'education'
    | 'featured-hunt-fish'
    | 'fishing'
    | 'hiking'
    | 'horseback_riding'
    | 'hunting'
    | 'orv_ohv_atv'
    | 'paddling'
    | 'water_activities'
    | 'wildlife_viewing'
    | 'winter_sports';

export interface ActivityTagOption {
    label: string;
    value: ActivityTagValue;
}

export const ACTIVITY_TAG_OPTIONS: ActivityTagOption[] = [
    { label: 'Biking', value: 'biking' },
    { label: 'Water Activities', value: 'water_activities' },
    { label: 'Hiking', value: 'hiking' },
    { label: 'Fishing', value: 'fishing' },
    // { label: 'Hunting', value: 'hunting' },
    { label: 'Wildlife Viewing', value: 'wildlife_viewing' },
    { label: 'Education / Programs', value: 'education' },
    // { label: 'Climbing', value: 'climbing' },
    // { label: 'Horseback Riding', value: 'horseback_riding' },
    // { label: 'Off-Roading', value: 'orv_ohv_atv' },
    // { label: 'Paddling', value: 'paddling' },
    // { label: 'Winter Sports', value: 'winter_sports' },
];

/**
 * A URL-only activity tag (?activity_tags=featured-hunt-fish). It isn't camping
 * related, so it's left out of ACTIVITY_TAG_OPTIONS, which the Nearby Activities
 * filters list. The filters dialog shows it in its own Featured section, and only
 * while it's active.
 */
export const FEATURED_HUNT_FISH_TAG: ActivityTagOption = {
    label: 'Featured Hunting & Fishing',
    value: 'featured-hunt-fish',
};

export const ALL_ACTIVITY_TAGS: ActivityTagOption[] = [
    ...ACTIVITY_TAG_OPTIONS,
    // Included so ACTIVITY_TAG_LABEL_MAP can resolve its display label
    FEATURED_HUNT_FISH_TAG,
];

export const ACTIVITY_TAG_LABEL_MAP: Record<string, string> = Object.fromEntries(
    ALL_ACTIVITY_TAGS.map((t) => [t.value, t.label])
);

/** What `uiFilters.activityTags` stores for a checked tag, keyed by the tag */
export interface ActivityTagSelection {
    key: string;
    /** The label shown in the UI, e.g. on the tag's pill */
    value: string;
    /** The activity tag sent to search */
    filters: { attribute: 'activity_tags'; filterValue: string }[];
}

/**
 * The selection for an activity tag, e.g. 'hiking'. The URL parser and every
 * activity tag control build it here, so the pill label stays the same however
 * the tag was checked. Unknown tags fall back to the tag itself as the label.
 */
export function toActivityTagSelection(tag: string): ActivityTagSelection {
    return {
        key: tag,
        value: ACTIVITY_TAG_LABEL_MAP[tag] ?? tag,
        filters: [{ attribute: 'activity_tags', filterValue: tag }],
    };
}

// cSpell:ignore horseback, off-roading
